import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const useBannerStore = create(
  combine({ isImageLoaded: false, isImageError: false }, (set) => ({ setBanner: set })),
);
